import { styled } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-left: auto;

	${Text} {
		font-size: 16px;
		font-weight: 700;
		color: #ffffff;
		transition: color 0.25s ease;
	}

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
		transition: filter 0.25s ease;
	}
`;

export { StyledContainer };
